import { Palette, Stack } from "@secuis/ccp-react-components";
import styled from "styled-components";

export const Banner = styled(Stack)`
    width: 100%;
    background-color: ${Palette.Navy850};
`;
